import { LitElement, html, css } from "lit";
export class Panel extends LitElement {
    render() {
        return html `<slot></slot>`;
    }
}
Panel.styles = css `
    :host {
      display: flex;
      flex-direction: row;
      height: var(--08);
      align-items: end;
      gap: var(--025);
    }
  `;
customElements.define("ds-panel", Panel);
